import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import InventoryCategories from '../../components/inventory/modals/InventoryCategories';
import InventoryTransactionTypes from '../../components/inventory/modals/InventoryTransactionTypes';
import InventorySuppliers from '../../components/inventory/modals/InventorySuppliers';
import InventoryItems from '../../components/inventory/modals/InventoryItems';
import InventoryTransactions from '../../components/inventory/modals/InventoryTransactions';
import Bundles from '../../components/inventory/modals/Bundles';
import RequirePermission from '../../components/RequirePermission';
import { SUB_MODULES } from '../../constants/subModulesConstants';

const InventoryPage = () => {
    // const [type, setType] = useState([]);

    return (
        <>
            <Typography variant="h4">Inventory</Typography>
            <List>
                <RequirePermission subModuleName={SUB_MODULES.ITEMS} minAccessLevel={1}>
                  <InventoryItems />
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.ITEM_BUNDLES} minAccessLevel={1}>
                  <Bundles />
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.TRANSACTIONS} minAccessLevel={1}>
                  <InventoryTransactions />
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.SUPPLIERS} minAccessLevel={1}>
                  <InventorySuppliers />
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.CATEGORIES} minAccessLevel={1}>
                  <InventoryCategories />
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.TRANSACTION_TYPES} minAccessLevel={1}>
                  <InventoryTransactionTypes />
                </RequirePermission>
            </List>
        </>
    );
};

export default InventoryPage;
